var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ui-lightbox-wrapper", class: _vm.layout }, [
    _vm.layout === "split-view"
      ? _c("div", [
          _c("div", { staticClass: "ui-light-box-image" }),
          _vm._v(" "),
          _c("div", { staticClass: "ui-light-box-form" }, [
            _c("div", [_vm._t("default")], 2)
          ])
        ])
      : _c("div", [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }